// 引入css
import './css/yoyo.css'

// vue
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/store'

// common helper
import Filter from './script/filter'
import Directive from './script/directive.js'
import Util from './script/util'

// project related components
import Main from './main.vue'
import NoPermission from './pageview/nopermission.vue'
import LoginFailed from './pageview/unionLoginFailed.vue'
import InfoGuide from './pageview/infoGuide.vue'
import Present from './pageview/present.vue'

import Heatmap from './pageview/web/heatmap.vue'
import PersonDetail from './pageview/setting/personDetail.vue'
import vTags from 'v-tags'
import { webRouter, settingRouter, appRouter } from './router/index'
import Vue360Analysis from 'vue-fx'
import VueResource from 'vue-resource'

// 注册全局组件
import * as Commponent from './component/index'
Object.keys(Commponent).forEach(name => {
  Vue.component(name, Commponent[name])
})

// use v-tag
Vue.use(vTags)
// web请求服务配置
Vue.use(VueResource)

/********************************************************************
 *                               Router
 ********************************************************************/
Vue.use(VueRouter)
// 路由配置 todo 将路由这块放在 rooter 目录中，只是导出一个 roter 对象

// 拦截是否登录
const beforeEnter = function (to, from, next) {
  const isLogin = Boolean(window.$userName)
  const hasDomain = window.$domainList.length === 0

  if (isLogin) {
    if (
      from.path === '/nopermission' &&
      hasDomain &&
      !/^\/(help|login)/.test(to.path)
    ) {
      location.replace('/login/doAuth')
    } else {
      next(true)
    }
  } else {
    next('/')
  }
}

webRouter.beforeEnter = beforeEnter
settingRouter.beforeEnter = beforeEnter
appRouter.beforeEnter = beforeEnter

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      webRouter,
      appRouter,
      settingRouter,
      {
        path: 'nopermission',
        component: NoPermission
      },
      {
        path: 'unionLoginFailed',
        component: LoginFailed
      },
      {
        path: 'infoguide',
        component: InfoGuide
      }
    ]
  },
  {
    path: '/present',
    component: Present
  },
  {
    path: '/setting/personDetail',
    component: PersonDetail,
    beforeEnter (to, from, next) {
      if (window.$userName) {
        if (window.$domainList.length) {
          next(true)
        } else {
          next('/setting/sites')
        }
      } else {
        next('/')
      }
    }
  },
  {
    path: '/web/heatmap',
    component: Heatmap,
    beforeEnter (to, from, next) {
      if (window.$userName) {
        if (window.$domainList.length) {
          next(true)
        } else {
          next('/setting/sites')
        }
      } else {
        next('/')
      }
    }
  },
  {
    path: '*',
    redirect: '/web/overview',
    beforeEnter
  }
]
const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  linkActiveClass: 'active',
  routes: routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
Vue360Analysis(router, 433132)

/********************************************************************
 * App mount
 ********************************************************************/
// 事件总线
Vue.$EventBus = new Vue()

// 挂载vue实例到页面
new Vue({
  store,
  router,
  render: h => h('router-view')
}).$mount('#wrapper')




// WEBPACK FOOTER //
// ./src/index.js